import type * as ents from '@attain-apps/entities'
import { TypeChecker } from '@attain-apps/type-guards'

import { SPACE_RECORDS_SELECTION_TARGET } from '../../constants'

import type { Plugin } from './plugin'

/**
 * Selectors for record cluster assignment state.
 */
export class Selectors {
  /** Active cluster assignment workflow. */
  // NOTE: intentionally missing return type so that type can be inferred
  public readonly assignment
  /** Whether the assignment workflow is active. */
  // NOTE: intentionally missing return type so that type can be inferred
  public readonly isAssigningCluster
  /** Whether assignment submit is in flight. */
  // NOTE: intentionally missing return type so that type can be inferred
  public readonly isSubmitting
  /** Last assignment submit error. */
  // NOTE: intentionally missing return type so that type can be inferred
  public readonly error
  /** Records anchored to the active assignment workflow. */
  // NOTE: intentionally missing return type so that type can be inferred
  public readonly assignmentRecords
  /** Cluster id selected in the assignment selector. */
  // NOTE: intentionally missing return type so that type can be inferred
  public readonly selectedClusterId

  constructor(plugin: Plugin) {
    this.assignment = plugin.feature.state.project(state => state.assignment)
    this.isAssigningCluster = this.assignment.project(Boolean)
    this.isSubmitting = this.assignment.project(
      assignment => assignment?.isSubmitting ?? false,
    )
    this.error = this.assignment.project(assignment => assignment?.error)
    this.assignmentRecords = this.assignment.project(
      plugin.collection.plugins.selectionPlugin.feature.selectors.getAllSelected(
        {
          target: SPACE_RECORDS_SELECTION_TARGET,
        },
      ).asSelector,
      (assignment, selectedRecords): readonly ents.extra.space.Record[] =>
        assignment ? selectedRecords.filter(TypeChecker.isNotNullish.raw) : [],
    )
    this.selectedClusterId =
      plugin.clustersEc.plugins.selectionPlugin.feature.selectors.getFirstSelectedId(
        {
          target: SPACE_RECORDS_SELECTION_TARGET,
        },
      )
  }
}
